const contactCentersStyle = {
	right: {
		float: 'right',
	},
	addRecord: {
		cursor: 'pointer',
		marginTop: '4px',
		padding: '12px 0 12px 12px',
		'&:hover,&:focus': {
			filter: 'invert(1)',
		},
	},
	cardHeader: {
		position: 'absolute',
	},
};

export default contactCentersStyle;
